import { get, isEmpty } from 'lodash';
import { createSelector } from 'reselect';
import { SCOPE } from './types';
import { modeSelector } from '../selectors';
import { MODE_ALERT_DIAGNOSTICS } from '../constants';

const selector = state => get(state, SCOPE);

export default selector;

export const alertEventSelector = createSelector(
  selector,
  state => state.selectedEvent,
);

export const alertSelector = createSelector(
  selector,
  alerts => ({
    alert: get(alerts, 'selectedEvent.alert'),
  }),
);

export const hasManualAlertSelector: any = createSelector(
  alertSelector,
  modeSelector,
  (alert, { mode }) => {
    return (
      mode === MODE_ALERT_DIAGNOSTICS || window.location.pathname.includes('/alert/diagnostics')
    ) && !isEmpty(alert);
  }
);
